export enum BaseParameterTypes {
  HOOKLOAD = 'HOOKLOAD',
  STANDPIPE_PRESSURE = 'STANDPIPE_PRESSURE',
  DEPTH_HOLE = 'DEPTH_HOLE',
  ROTARY_TORQUE = 'ROTARY_TORQUE',
  BLOCK_POSITION = 'BLOCK_POSITION',
  DEPTH_BIT = 'DEPTH_BIT',
  MUD_FLOW_IN = 'MUD_FLOW_IN',
  RATE_OF_PENETRATION = 'RATE_OF_PENETRATION',
  WEIGHT_ON_BIT = 'WEIGHT_ON_BIT',
  ROTARY_SPEED = 'ROTARY_SPEED',
  AUTO_RECOGNIZED_EVENTS = 'AUTO_RECOGNIZED_EVENTS',
  AUTO_RECOGNIZED_OPERATIONS = 'AUTO_RECOGNIZED_OPERATIONS',
  MAGNETIC_TOOLFACE = 'MAGNETIC_TOOLFACE',
  GRAVITY_TOOLFACE = 'GRAVITY_TOOLFACE',
  BIT_SPEED = 'BIT_SPEED',
  BIT_CONTACT_PRESSURE = 'BIT_CONTACT_PRESSURE',
  MECH_SPEC_ENERGY_BIT = 'MECH_SPEC_ENERGY_BIT',
  MECH_SPEC_ENERGY_SURFACE = 'MECH_SPEC_ENERGY_SURFACE',
  MUD_FLOW_OUT = 'MUD_FLOW_OUT',
  MUD_FLOW_OUT_PERCENT = 'MUD_FLOW_OUT_PERCENT',
  TOTAL_PUMPS_STROKE_RATE = 'TOTAL_PUMPS_STROKE_RATE',
  SURFACE_ANNULAR_PRESSURE = 'SURFACE_ANNULAR_PRESSURE',
  MUD_DENSITY_IN = 'MUD_DENSITY_IN',
  MUD_DENSITY_OUT = 'MUD_DENSITY_OUT',
  ECD_AT_BIT = 'ECD_AT_BIT',
  ECD_AT_TOTAL_DEPTH = 'ECD_AT_TOTAL_DEPTH',
  RUNNING_SPEED = 'RUNNING_SPEED',
  ACTIVE_TANK_VOLUME = 'ACTIVE_TANK_VOLUME',
  TRIP_TANK_VOLUME = 'TRIP_TANK_VOLUME',
  TOTAL_GAS = 'TOTAL_GAS',
  SURVEY_INC = 'SURVEY_INC',
  SURVEY_AZI = 'SURVEY_AZI',
  SURVEY_AZI_CORR = 'SURVEY_AZI_CORR',
  SURVEY_DOGLEG = 'SURVEY_DOGLEG',
  RESISTIVITY_1 = 'RESISTIVITY_1',
  RESISTIVITY_2 = 'RESISTIVITY_2',
  GAMMA_RAY_1 = 'GAMMA_RAY_1',
  GAMMA_RAY_2 = 'GAMMA_RAY_2',
  POROSITY_1 = 'POROSITY_1',
  POROSITY_2 = 'POROSITY_2',
  THERMAL_NEUTRON_POROSITY = 'THERMAL_NEUTRON_POROSITY',
  NUMBER_OF_JOINTS = 'NUMBER_OF_JOINTS',
}

export const timeSortedParametersNoAutoRecognized = [
  BaseParameterTypes.DEPTH_HOLE,
  BaseParameterTypes.DEPTH_BIT,
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.MUD_FLOW_OUT,
  BaseParameterTypes.MUD_FLOW_OUT_PERCENT,
  BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.SURFACE_ANNULAR_PRESSURE,
  BaseParameterTypes.MUD_DENSITY_IN,
  BaseParameterTypes.MUD_DENSITY_OUT,
  BaseParameterTypes.ECD_AT_BIT,
  BaseParameterTypes.ECD_AT_TOTAL_DEPTH,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.RUNNING_SPEED,
  BaseParameterTypes.ACTIVE_TANK_VOLUME,
  BaseParameterTypes.TRIP_TANK_VOLUME,
  BaseParameterTypes.TOTAL_GAS,
  BaseParameterTypes.SURVEY_INC,
  BaseParameterTypes.SURVEY_AZI,
  BaseParameterTypes.SURVEY_AZI_CORR,
  BaseParameterTypes.SURVEY_DOGLEG,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
  BaseParameterTypes.NUMBER_OF_JOINTS,
] as const;

export const timeSortedParameters = [
  BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS,
  BaseParameterTypes.AUTO_RECOGNIZED_EVENTS,
  ...timeSortedParametersNoAutoRecognized,
] as const;

export const depthSortedParameters = [
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.MUD_FLOW_OUT,
  BaseParameterTypes.MUD_FLOW_OUT_PERCENT,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.MUD_DENSITY_IN,
  BaseParameterTypes.MUD_DENSITY_OUT,
  BaseParameterTypes.ECD_AT_BIT,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.TOTAL_GAS,
  BaseParameterTypes.SURVEY_INC,
  BaseParameterTypes.SURVEY_AZI,
  BaseParameterTypes.SURVEY_AZI_CORR,
  BaseParameterTypes.SURVEY_DOGLEG,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
  BaseParameterTypes.RESISTIVITY_1,
  BaseParameterTypes.RESISTIVITY_2,
  BaseParameterTypes.GAMMA_RAY_1,
  BaseParameterTypes.GAMMA_RAY_2,
  BaseParameterTypes.POROSITY_1,
  BaseParameterTypes.POROSITY_2,
  BaseParameterTypes.THERMAL_NEUTRON_POROSITY,
] as const;

export const nameDictionary: Record<BaseParameterTypes, string> = {
  [BaseParameterTypes.DEPTH_HOLE]: 'holeDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: 'operation',
  [BaseParameterTypes.DEPTH_BIT]: 'bitDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: 'event',
  [BaseParameterTypes.HOOKLOAD]: 'hookload',
  [BaseParameterTypes.STANDPIPE_PRESSURE]: 'standpipePressure',
  [BaseParameterTypes.ROTARY_TORQUE]: 'rotaryTorque',
  [BaseParameterTypes.BLOCK_POSITION]: 'blockPosition',
  [BaseParameterTypes.MUD_FLOW_IN]: 'mudFlowIn',
  [BaseParameterTypes.ROTARY_SPEED]: 'rotarySpeed',
  [BaseParameterTypes.WEIGHT_ON_BIT]: 'weightOnBit',
  [BaseParameterTypes.RATE_OF_PENETRATION]: 'penetrationRate',
  [BaseParameterTypes.GRAVITY_TOOLFACE]: 'gravityToolface',
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: 'magneticToolface',
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: 'bitContactPressure',
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: 'mechSpecEnergySurface',
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: 'mechSpecEnergyBit',
  [BaseParameterTypes.BIT_SPEED]: 'bitSpeed',
  [BaseParameterTypes.MUD_FLOW_OUT]: 'mudFlowOut',
  [BaseParameterTypes.MUD_FLOW_OUT_PERCENT]: 'mudFlowOutPercent',
  [BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE]: 'totalPumpsStrokeRate',
  [BaseParameterTypes.SURFACE_ANNULAR_PRESSURE]: 'surfaceAnnularPressure',
  [BaseParameterTypes.MUD_DENSITY_IN]: 'mudDensityIn',
  [BaseParameterTypes.MUD_DENSITY_OUT]: 'mudDensityOut',
  [BaseParameterTypes.ECD_AT_BIT]: 'ecdAtBit',
  [BaseParameterTypes.ECD_AT_TOTAL_DEPTH]: 'ecdAtTotalDepth',
  [BaseParameterTypes.RUNNING_SPEED]: 'runningSpeed',
  [BaseParameterTypes.ACTIVE_TANK_VOLUME]: 'activeTankVolume',
  [BaseParameterTypes.TRIP_TANK_VOLUME]: 'tripTankVolume',
  [BaseParameterTypes.TOTAL_GAS]: 'totalGas',
  [BaseParameterTypes.SURVEY_INC]: 'surveyInc',
  [BaseParameterTypes.SURVEY_AZI]: 'surveyAzi',
  [BaseParameterTypes.SURVEY_AZI_CORR]: 'surveyAziCorr',
  [BaseParameterTypes.SURVEY_DOGLEG]: 'surveyDogleg',
  [BaseParameterTypes.RESISTIVITY_1]: 'resistivity1',
  [BaseParameterTypes.RESISTIVITY_2]: 'resistivity2',
  [BaseParameterTypes.GAMMA_RAY_1]: 'gammaRay1',
  [BaseParameterTypes.GAMMA_RAY_2]: 'gammaRay2',
  [BaseParameterTypes.POROSITY_1]: 'porosity1',
  [BaseParameterTypes.POROSITY_2]: 'porosity2',
  [BaseParameterTypes.THERMAL_NEUTRON_POROSITY]: 'thermalNeutronPorosity',
  [BaseParameterTypes.NUMBER_OF_JOINTS]: 'numberOfJoints',
};

export const baseParamsToMnemonic: Record<BaseParameterTypes, readonly string[]> = {
  [BaseParameterTypes.HOOKLOAD]: ['HKLA'],
  [BaseParameterTypes.STANDPIPE_PRESSURE]: ['SPPA'],
  [BaseParameterTypes.DEPTH_HOLE]: ['DMEA'],
  [BaseParameterTypes.ROTARY_TORQUE]: ['TQA'],
  [BaseParameterTypes.BLOCK_POSITION]: ['BPOS'],
  [BaseParameterTypes.DEPTH_BIT]: ['DBTM'],
  [BaseParameterTypes.MUD_FLOW_IN]: ['MFI'],
  [BaseParameterTypes.RATE_OF_PENETRATION]: ['ROP'],
  [BaseParameterTypes.WEIGHT_ON_BIT]: ['WOB'],
  [BaseParameterTypes.ROTARY_SPEED]: ['RPM'],
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: ['OP'],
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: ['KPI'],
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: ['SMTF'],
  [BaseParameterTypes.GRAVITY_TOOLFACE]: ['SGTF'],
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: ['DBHP'],
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: ['SMSE'],
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: ['DMSE'],
  [BaseParameterTypes.BIT_SPEED]: ['BIT_RPM'],
  [BaseParameterTypes.MUD_FLOW_OUT]: ['MFOA'],
  [BaseParameterTypes.MUD_FLOW_OUT_PERCENT]: ['MFOP'],
  [BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE]: ['STRC'],
  [BaseParameterTypes.SURFACE_ANNULAR_PRESSURE]: ['CHKP'],
  [BaseParameterTypes.MUD_DENSITY_IN]: ['MDIA'],
  [BaseParameterTypes.MUD_DENSITY_OUT]: ['MDOA'],
  [BaseParameterTypes.ECD_AT_BIT]: ['ECDB'],
  [BaseParameterTypes.ECD_AT_TOTAL_DEPTH]: ['ECDT'],
  [BaseParameterTypes.RUNNING_SPEED]: ['RSA'],
  [BaseParameterTypes.ACTIVE_TANK_VOLUME]: ['TVA'],
  [BaseParameterTypes.TRIP_TANK_VOLUME]: ['TTV1', 'TTV2'],
  [BaseParameterTypes.TOTAL_GAS]: ['GASA'],
  [BaseParameterTypes.SURVEY_INC]: ['SINC'],
  [BaseParameterTypes.SURVEY_AZI]: ['SAZU'],
  [BaseParameterTypes.SURVEY_AZI_CORR]: ['SAZC'],
  [BaseParameterTypes.SURVEY_DOGLEG]: ['SDLS'],
  [BaseParameterTypes.RESISTIVITY_1]: ['MR1', 'MR1C'],
  [BaseParameterTypes.RESISTIVITY_2]: ['MR2', 'MR2C'],
  [BaseParameterTypes.GAMMA_RAY_1]: ['MG1', 'MG1C'],
  [BaseParameterTypes.GAMMA_RAY_2]: ['MG2', 'MG2C'],
  [BaseParameterTypes.POROSITY_1]: ['MPO1'],
  [BaseParameterTypes.POROSITY_2]: ['MPO2'],
  [BaseParameterTypes.THERMAL_NEUTRON_POROSITY]: ['TNPH'],
  [BaseParameterTypes.NUMBER_OF_JOINTS]: ['JOINTS_RUN'],
};
